import React, { useState, useEffect } from 'react';
import { today } from 'helpers.js';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { useSelector } from 'react-redux';
import { utils, writeFileXLSX } from 'xlsx';
import _ from 'lodash';

import { getPortafoglio } from './functions';

const { SearchBar } = Search;

const Portafoglio = () => {
  const [filter, setFilter] = useState('cliente');
  const [date, setDate] = useState(today());
  const [portafoglioFilter, setPortafoglioFilter] = useState([]);

  const { portafoglio } = useSelector((state) => state.bi);

  function filterData(p) {
    const coso = _.groupBy(p, 'Zone');
    const robabella = [];
    Object.keys(coso).forEach((c) => {
      robabella.push({
        Zona: c,
        Anno: _.sumBy(coso[c], 'Anno'),
        AnnoInCorso: _.sumBy(coso[c], 'AnnoInCorso'),
        AnnoMenoUno: _.sumBy(coso[c], 'AnnoMenoUno'),
        OrdiniAttivi: _.sumBy(coso[c], 'OrdiniAttivi'),
        OrdiniProspettici: _.sumBy(coso[c], 'OrdiniProspettici'),
        Portafoglio: _.sumBy(coso[c], 'Portafoglio'),
      });
    });
    console.log(robabella);
    return robabella;
  }
  useEffect(() => {
    getPortafoglio(date);
  }, [date]);

  useEffect(() => {
    setPortafoglioFilter(filterData(portafoglio));
  }, [portafoglio]);

  const onDownload = () => {
    const sheet = utils.table_to_sheet(document.getElementById('tabella-portafoglio-cliente'));
    const wb = utils.book_new();
    utils.book_append_sheet(wb, sheet, 'Data');
    writeFileXLSX(wb, 'data.xlsx');
  };

  return (
    <div className="portafoglio">
      <section id="scroll-section" className="mb-3">
        <h1>Portafoglio</h1>
      </section>
      <section className="mb-3">
        <ul className="nav nav-pills justify-content-between">
          <div className="w-50 nav nav-justified" style={{ maxWidth: 500 }}>
            <li className="nav-item me-2">
              <button
                className={`nav-link ${filter === 'cliente' ? 'active' : 'bg-light text-light'} rounded-pill border`}
                type="button"
                onClick={() => setFilter('cliente')}
              >
                Cliente
              </button>
            </li>

            <li className="nav-item">
              <button
                className={`nav-link ${filter === 'zona' ? 'active' : 'bg-light text-light'} rounded-pill border`}
                type="button"
                onClick={() => setFilter('zona')}
              >
                Zona
              </button>
            </li>
          </div>

          <div className="w-50 nav justify-content-end" style={{ maxWidth: 400 }}>
            <li className="nav-item me-2">
              <input type="date" className="form-control rounded-pill" value={date} onChange={(e) => setDate(e.target.value)} />
            </li>

            <li className="nav-item">
              <button className="btn btn-primary rounded-pill" onClick={onDownload} type="button">
                Export table
              </button>
            </li>
          </div>
        </ul>
      </section>
      <section>
        <div className="card card-body">
          {filter === 'cliente' ? (
            <ToolkitProvider
              keyField="Cliente"
              data={portafoglio}
              columns={[
                { dataField: 'Cliente' },
                { dataField: 'Anno', text: 'Anno', format: true },
                { dataField: 'OrdiniAttivi', text: 'Ordini Attivi', format: true },
                { dataField: 'OrdiniProspettici', text: 'Ordini Prospettici', format: true },
                { dataField: 'Portafoglio', text: 'Portafoglio', format: true },
                { dataField: 'AnnoInCorso', text: 'Anno In Corso', format: true },
                { dataField: 'AnnoMenoUno', text: 'Anno Meno Uno', format: true },
                {
                  dataField: null,
                  text: '%',
                  formatter: (x, row) => {
                    return `${((row?.AnnoInCorso * 100) / row?.AnnoMenoUno).toFixed(2)}%`;
                  },
                },
              ].map((col) => {
                if (col.format) {
                  return {
                    ...col,
                    formatter: (cell) => `€ ${cell ? Number(cell).toFixed(2) : 0.0}`,
                  };
                }
                return col;
              })}
              search
            >
              {(props) => (
                <div>
                  <SearchBar {...props.searchProps} /> <hr />
                  <BootstrapTable id="tabella-portafoglio-cliente" striped bootstrap4 wrapperClasses="table-responsive" {...props.baseProps} />
                </div>
              )}
            </ToolkitProvider>
          ) : (
            <ToolkitProvider
              keyField="Zona"
              data={portafoglioFilter}
              columns={[
                { dataField: 'Zona', text: 'Zona' },
                { dataField: 'Anno', text: 'Anno', format: true },
                { dataField: 'OrdiniAttivi', text: 'Ordini Attivi', format: true },
                { dataField: 'OrdiniProspettici', text: 'Ordini Prospettici', format: true },
                { dataField: 'Portafoglio', text: 'Portafoglio', format: true },
                { dataField: 'AnnoInCorso', text: 'Anno In Corso', format: true },
                { dataField: 'AnnoMenoUno', text: 'Anno Meno Uno', format: true },
                {
                  dataField: null,
                  text: '%',
                  formatter: (x, row) => {
                    return `${((row?.AnnoInCorso * 100) / row?.AnnoMenoUno).toFixed(2)}%`;
                  },
                },
              ].map((col) => {
                if (col.format) {
                  return {
                    ...col,
                    formatter: (cell) => `€ ${cell ? Number(cell).toFixed(2) : 0.0}`,
                  };
                }
                return col;
              })}
              search
            >
              {(props) => (
                <div>
                  <SearchBar {...props.searchProps} /> <hr />
                  <BootstrapTable id="tabella-portafoglio-cliente" striped bootstrap4 wrapperClasses="table-responsive" {...props.baseProps} />
                </div>
              )}
            </ToolkitProvider>
          )}
        </div>
      </section>
    </div>
  );
};

export default Portafoglio;
